import React, { useEffect, useState, useCallback } from "react";
import { FlatList, StyleSheet, View, useWindowDimensions } from "react-native";
import { useFocusEffect } from "@react-navigation/native";

import ListingCard from "../components/ListingCard";
import config from "../config/config";
import Screen from "../components/Screen";
import AppText from "../components/AppText";
import IconTouchable from "../components/IconTouchable";
import useUser from "../hooks/useUser";
import useProducts from "../hooks/useProducts";
import TabSelector from "../components/TabSelector";
import Container from "../components/Container";

function StoreScreen({ navigation }) {
    const { user } = useUser();
    const { products, getProducts, loading } = useProducts();
    const [extraData, setExtraData] = useState(false);

    const window = useWindowDimensions();

    const [selectedStatus, setSelectedStatus] = useState("for sale");
    const [selectedCategory, setSelectedCategory] = useState(false);

    useEffect(() => {
        getProducts();
    }, []);

    // Used to refresh the flatlist after new product data has been received.
    useFocusEffect(
        useCallback(() => {
            setExtraData(!extraData);
        }, [])
    );

    return (
        <Screen
            title={"Store"}
            capitulize={true}
            navigation={navigation}
            loading={loading}
            rightIconComponent={user.type == "admin" && <IconTouchable name="tools" onPress={() => navigation.navigate("Tools")} />}
        >
            {user.type == "admin" && (
                <Container>
                    <TabSelector
                        tabs={[
                            { name: "For Sale", status: "for sale" },
                            { name: "Sold", status: "sold" },
                            { name: "Archive", status: "archive" },
                        ]}
                        onPress={(value) => setSelectedStatus(value.status)}
                    />
                </Container>
            )}
            <View style={{ paddingBottom: 10 }} />
            <Container>
                <TabSelector
                    tabs={[{ name: "Engines" }, { name: "Gearboxes" }, { name: "Other" }]}
                    onPress={(value) => setSelectedCategory(value.name)}
                />
            </Container>
            <FlatList
                data={
                    selectedCategory
                        ? products.filter((x) => x.category == selectedCategory).filter((y) => y.status == selectedStatus)
                        : products.filter((x) => x.status == selectedStatus)
                }
                key={window.width > 758 ? "h" : "v"}
                numColumns={window.width > 758 ? 3 : 1}
                extraData={extraData}
                keyExtractor={(item) => item._id}
                horizontal={false}
                showsVerticalScrollIndicator={false}
                ListEmptyComponent={
                    <View style={{ alignItems: "center", paddingTop: 50 }}>
                        <AppText style={{ color: config.colors.white, fontWeight: "bold", textAlign: "center", fontSize: 20 }}>
                            {"No Results\n" + "Please amend your search above"}
                        </AppText>
                    </View>
                }
                renderItem={({ item }) => <ListingCard product={item} navigation={navigation} />}
            />
        </Screen>
    );
}

const styles = StyleSheet.create({
    text: {
        alignSelf: "center",
        fontSize: 16,
        fontWeight: "900",
        color: config.colors.white,
        textTransform: "capitalize",
    },
    selectorIcons: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        paddingVertical: 5,
    },
    typeSelectorIcons: {
        flexDirection: "row",
        justifyContent: "space-around",
        paddingBottom: 30,
    },
    buttonBoxLeft: {
        alignItems: "center",
        flexDirection: "row",
    },
    buttonBoxRight: {
        alignItems: "center",
        flexDirection: "row",
    },
    selector: {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        backgroundColor: config.colors.secondary,
        borderRadius: 5,
        paddingHorizontal: 10,
    },
});

export default StoreScreen;
